module.exports = __webpack_public_path__ + "static/media/IMG_0589.d9f12453.jpg";